
import { defineComponent, SetupContext, PropType } from "vue";
import MyListFolderListItem from "./MyListFolderListItem.vue";
import { FolderInfo, FOLDER_ID_ALL } from "@/types/recipes";

export default defineComponent({
  name: "MyListFolderList",
  components: { MyListFolderListItem },
  props: {
    folderList: {
      type: Array as PropType<FolderInfo[]>,
      default: () => []
    }
  },
  setup(props, context: SetupContext) {
    const selectCheck = (folderId: number, checked: boolean) => {
      context.emit("select-check", folderId, checked);
    };
    const isAll = (folderId: number) => {
      return folderId == FOLDER_ID_ALL;
    };
    return {
      selectCheck,
      isAll
    };
  }
});
